import EmptyImg from 'assets/svgs/empty.svg';
import ErrorImg from 'assets/svgs/error.svg';
import SuccessImg from 'assets/svgs/success.svg';

export type DndDragEndEvent = {
  active: {
    data?: {
      current: any;
    };
    id: number | string;
    rect: Record<string, any>;
  };
  delta: Record<string, any>;
  over: null | Record<string, any>;
};

export enum GuessStates {
  ERROR = 'error',
  NULL = 'null',
  SUCCESS = 'success',
}

export const GuessImgSrcMap = {
  [GuessStates.ERROR]: ErrorImg,
  [GuessStates.NULL]: EmptyImg,
  [GuessStates.SUCCESS]: SuccessImg,
};
